export default ({visionBoard, maxSelection = 10}) => ({
    visionBoard,
    maxSelection,
    countSelectedMedias: 0,
    get disabledWhenMaxSelection() {
        return this.visionBoard.length === this.maxSelection;
    },
    countSelectedMediasByType(type) {
        return this.visionBoard.filter(media => media.type === type).length;
    },
    isMediaSelected(selectedMedia) {
        const found = this.visionBoard.find(media => media.id === selectedMedia.id && media.type === selectedMedia.type);

        return found !== undefined;
    },
    detachMedia(selectedMedia) {
        this.visionBoard = this.visionBoard.filter(media => {
            if (media.type !== selectedMedia.type) {
                return true;
            }

            return media.id !== selectedMedia.id;
        });
    },
    handleSelectedMedia(selectedMedia) {
        if (!this.isMediaSelected(selectedMedia) && this.canSelectMoreMedia()) {
            this.visionBoard.push(selectedMedia);
        } else {
            this.detachMedia(selectedMedia);
        }

        this.updateCount();

        this.$dispatch('sync-selected-medias-with-modal', {selectedMedias: Alpine.raw(this.visionBoard)});
    },
    toggleMedia(event, selectedMedia) {
        const checkbox = event.currentTarget.querySelector('input[type=checkbox]');

        if (!checkbox) {
            return
        }

        if (this.disabledWhenMaxSelection) {
            checkbox.checked = false;

            return this.handleSelectedMedia(selectedMedia);
        }

        checkbox.checked = !checkbox.checked;

        this.handleSelectedMedia(selectedMedia);
    },
    canSelectMoreMedia() {
        return this.visionBoard.length < this.maxSelection && !this.disabledWhenMaxSelection;
    },
    syncMedias(event) {
        this.visionBoard = event.detail.selectedMedias;
        this.updateCount();
    },
    updateCount() {
        this.countSelectedMedias = this.visionBoard.length;
        this.$dispatch('sync-count-selected-medias', {count: this.countSelectedMedias});
    },
    init() {
        this.updateCount();

        this.$nextTick(() => {
            this.$dispatch('sync-selected-medias-with-modal', {selectedMedias: Alpine.raw(this.visionBoard)});
        });
    }
})
